<template>
  <div>
    <div
      style="display: flex; justify-content: space-between; width: 100%; margin-bottom: 5px;">
      <select ref="logica" v-model="logica" required>
        <option v-for="(val, key) in logicas" :value="`${key}`" :key="key">
          {{val}}
        </option>
      </select>

      <div>
        <label>Campo:</label>
        <select ref="coluna" v-model="coluna" required>
          <option v-for="(val, key) in columns" :value="`${key}`" :key="key">
            {{val}}
          </option>
        </select>
      </div>

      <div>
        <label>Condição:</label>
        <select ref="condicao" v-model="condicao" required>
          <option v-for="(val, key) in condicoes" :value="`${key}`" :key="key">
            {{val}}
          </option>
        </select>
      </div>

      <div>
        <label>Valor:</label>
        <input v-model="valor" style="width: 150px;">
      </div>

      <div>
        <button type="button" class="btn-small" @click="add()">
          <i class="mdi mdi-plus mdi-18px"></i>
        </button>
        <button type="button" class="btn-small" @click="clear()">
          <i class="mdi mdi-eraser mdi-18px"></i>
        </button>
      </div>

    </div>

    <s-data-table :columns="columnsHeaders" :items="internalValue"
      style="height: 340px;">
      <template #item="{ item, column, index }">
        <div v-if="column.value === 'actions'">
          <button type="button" class="btn-small" @click="del(index)">
            <i class="mdi mdi-minus mdi-18px"></i>
          </button>
        </div>
        <span v-else>{{ item[column.value] }}</span>
      </template>
    </s-data-table>
  </div>
</template>

<script>
export default {
  name: "s-report-filters",

  props: {
    value: Array,
    columns: Object,
  },

  data() {
    return {
      valor: "",
      coluna: "",
      logica: "and",
      condicao: "",
      logicas: {
        "and": "E",
        "or": "OU",
      },
      condicoes: {
        "ilike '%?%'": "Contém",
        "ilike '?%'": "Inicia",
        "ilike '%?'": "Termina",
        "< '?'": "Menor",
        "= '?'": "Igual",
        "> '?'": "Maior",
        ">= '?'": "Maior ou Igual",
        "<= '?'": "Menor ou Igual",
      },
    };
  },

  computed: {
    columnsHeaders() {
      return [
        { text: "Lógica", align: "center", value: "logical" },
        { text: "Campo", align: "left", value: "colunm" },
        { text: "Condição", align: "center", value: "conditional" },
        { text: "Valor", align: "left", value: "value" },
        { text: "", align: "center", value: "actions", maxWidth: 70 },
      ];
    },

    internalValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    add() {
      if (!this.coluna) {
        Notify.warning("Informe o campo");
        this.$refs.coluna.focus();
        return;
      }
      if (!this.condicao) {
        Notify.warning("Informe a condição");
        this.$refs.condicao.focus();
        return;
      }

      const logica = this.internalValue.length ? this.logica : "";

      this.internalValue.push({
        value: this.valor,
        colunm: this.columns[this.coluna],
        logical: logica ? this.logicas[logica] : "",
        condition: " " + logica + " " + this.coluna + " " + this.condicao
          .replace("?", this.valor),
        conditional: this.condicoes[this.condicao],
      });
      this.$emit("input", this.value);
      this.$refs.logica.focus();
    },

    del(index) {
      this.internalValue.splice(index, 1);
      this.$refs.logica.focus();
    },

    clear() {
      this.internalValue = [];
    },
  },
};
</script>